import { Form as FormikForm } from 'formik'
import styled from 'styled-components'

import { up } from '@Globals/Style/breakpoints'
import { box, flexCenterChildrenColumn, loadingWrap } from '@Globals/Style/mixins'

export const Overlay = styled.div`
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
  ${flexCenterChildrenColumn}

  .smallLoadingWrap {
    ${loadingWrap}
  }

  .header {
    ${flexCenterChildrenColumn}

    .iconWrap {
      display: none;
      ${up('phablet')} {
        display: block;
      }
      margin-bottom: 5px;
      ${box({ width: '50px' })}

      svg {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }

    span {
      width: 100%;
      margin-bottom: 10px;
      text-align: center;
      font-size: 1.5rem;
    }
  }
`

export const Banner = styled.div`
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 20px;

  &.error {
    color: ${({ theme }) => theme.colors.red};
    border: 1px solid ${({ theme }) => theme.colors.red};
    background-color: ${({ theme }) => theme.colors.greyLightestest};
  }

  &.success {
    color: ${({ theme }) => theme.colors.primary};
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }
`

export const Form = styled(FormikForm)`
  width: 100%;
  .buttonsWrap {
    margin-top: 25px;
    width: 100%;

    .resetPassword {
      display: block;
      color: ${({ theme }) => theme.colors.primary};
      font-size: 0.875rem;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .createNewAccount {
      display: block;
      text-align: center;
      padding: 11px 20px 10px;
      background-color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.primary};
      margin-top: 20px;
      text-transform: uppercase;
      width: 100%;
      &:hover {
        background-color: ${({ theme }) => theme.colors.greyLightest};
        /* TODO: Add to theme (primary darkened 30%) */
        border-color: #34634a;
        color: #34634a;
      }
    }
  }
`
